import { render } from "./ReceivableListView.vue?vue&type=template&id=4fec8d32&scoped=true"
import script from "./ReceivableListView.vue?vue&type=script&lang=js"
export * from "./ReceivableListView.vue?vue&type=script&lang=js"

import "./ReceivableListView.vue?vue&type=style&index=0&id=4fec8d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fec8d32"]])

export default __exports__